webpackJsonp([104158497352714],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(43);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _fullLogoOnWhite = __webpack_require__(55);
	
	var _fullLogoOnWhite2 = _interopRequireDefault(_fullLogoOnWhite);
	
	var _reactStripeCheckout = __webpack_require__(78);
	
	var _reactStripeCheckout2 = _interopRequireDefault(_reactStripeCheckout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  if (typeof window !== "undefined" && window.fbq) {
	    window.fbq("track", "Lead");
	  }
	  return _react2.default.createElement(
	    "div",
	    { className: "container", "data-jsx": 3354395811
	    },
	    _react2.default.createElement(
	      "header",
	      {
	        "data-jsx": 3354395811
	      },
	      _react2.default.createElement(
	        "h1",
	        {
	          "data-jsx": 3354395811
	        },
	        "Sign up for Quiver"
	      )
	    ),
	    _react2.default.createElement("iframe", {
	      src: "https://dashboard.graphql-quiver.com/signup",
	      frameborder: "0",
	      id: "signup-iframe",
	      "data-form-source": "https://dashboard.graphql-quiver.com/signup",
	      "class": "iframe-form ",
	      "data-pass-through-params": "code next platform trial plan period referrer",
	      "data-jsx": 3354395811
	    }),
	    _react2.default.createElement(_style2.default, {
	      styleId: 3354395811,
	      css: "iframe[data-jsx=\"3354395811\"]{border:none;width:100%;height:600px}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9zaWdudXAuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUJrQixBQUd1QixZQUNELFdBQ0UsYUFDZiIsImZpbGUiOiJzcmMvcGFnZXMvc2lnbnVwLmpzIiwic291cmNlUm9vdCI6Ii9vcHQvYnVpbGQvcmVwbyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBMaW5rIGZyb20gXCJnYXRzYnktbGlua1wiO1xuaW1wb3J0IEZ1bGxMb2dvT25XaGl0ZSBmcm9tIFwiLi9mdWxsLWxvZ28tb24td2hpdGUuc3ZnXCI7XG5pbXBvcnQgU3RyaXBlQ2hlY2tvdXQgZnJvbSBcInJlYWN0LXN0cmlwZS1jaGVja291dFwiO1xuaW1wb3J0IHsgd2l0aFByZWZpeCB9IGZyb20gXCJnYXRzYnktbGlua1wiO1xuXG5leHBvcnQgZGVmYXVsdCAoKSA9PiB7XG4gIGlmICh0eXBlb2Ygd2luZG93ICE9PSBcInVuZGVmaW5lZFwiICYmIHdpbmRvdy5mYnEpIHtcbiAgICB3aW5kb3cuZmJxKFwidHJhY2tcIiwgXCJMZWFkXCIpO1xuICB9XG4gIHJldHVybiAoXG4gICAgPGRpdiBjbGFzc05hbWU9XCJjb250YWluZXJcIj5cbiAgICAgIDxoZWFkZXI+XG4gICAgICAgIDxoMT5TaWduIHVwIGZvciBRdWl2ZXI8L2gxPlxuICAgICAgPC9oZWFkZXI+XG4gICAgICA8aWZyYW1lXG4gICAgICAgIHNyYz1cImh0dHBzOi8vZGFzaGJvYXJkLmdyYXBocWwtcXVpdmVyLmNvbS9zaWdudXBcIlxuICAgICAgICBmcmFtZWJvcmRlcj1cIjBcIlxuICAgICAgICBpZD1cInNpZ251cC1pZnJhbWVcIlxuICAgICAgICBkYXRhLWZvcm0tc291cmNlPVwiaHR0cHM6Ly9kYXNoYm9hcmQuZ3JhcGhxbC1xdWl2ZXIuY29tL3NpZ251cFwiXG4gICAgICAgIGNsYXNzPVwiaWZyYW1lLWZvcm0gXCJcbiAgICAgICAgZGF0YS1wYXNzLXRocm91Z2gtcGFyYW1zPVwiY29kZSBuZXh0IHBsYXRmb3JtIHRyaWFsIHBsYW4gcGVyaW9kIHJlZmVycmVyXCJcbiAgICAgIC8+XG4gICAgICA8c3R5bGUganN4PntgXG4gICAgICAgIGlmcmFtZSB7XG4gICAgICAgICAgYm9yZGVyOiBub25lO1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgIGhlaWdodDogNjAwcHg7XG4gICAgICAgIH1cbiAgICAgIGB9PC9zdHlsZT5cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG4iXX0= */\n/*@ sourceURL=src/pages/signup.js */"
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-signup-js-48611214189a6437c006.js